var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"containerg container404"},[_c('i',{staticClass:"ri-error-warning-fill"}),_c('p',[_vm._v("Eroare 404!")]),_c('p',[_vm._v("Pagina nu exista.")]),_c('a',{staticClass:"btn_g_red",attrs:{"href":"/"}},[_vm._v("Acasa")])])
}]

export { render, staticRenderFns }